import angryNatural from "./angry-natural";
import angry from "./angry";
import basicNatural from "./basic-natural";
import basic from "./basic";
import flatNatural from "./flat-natural";
import frownNatural from "./frown-natural";
import raisedExcitedNatural from "./raised-excited-natural";
import raisedExcited from "./raised-excited";
import sadConcernedNatural from "./sad-concerned-natural";
import sadConcerned from "./sad-concerned";
import unibrowNatural from "./unibrow-natural";
import upDownNatural from "./up-down-natural";
import upDown from "./up-down";

export default {
	angryNatural,
	angry,
	basicNatural,
	basic,
	flatNatural,
	frownNatural,
	raisedExcitedNatural,
	raisedExcited,
	sadConcernedNatural,
	sadConcerned,
	unibrowNatural,
	upDownNatural,
	upDown,
};



// WEBPACK FOOTER //
// ./src/face/eyebrow/index.js